import { User } from '@property.com.au/argonaut';
import { useTrackView } from '../../hooks/useTrackView';
import { useSearchLandingPageContext } from '../contexts/SearchLandingPageContext/SearchLandingPageContext';
import { deepOmitTypeName } from '../../helpers/deepOmitTypeName';

// Tracking must be done via custom hook instead of in the entry file due to reliance on useExperimentsTrackingData hook
// See: https://pages.git.realestate.com.au/consumer-experience/argonaut/guides/experiment/#tealium-tracking-of-experiments

export const useSearchLandingPageTrackView = ({ user }: { user: User }) => {
  const { searchLandingPageData } = useSearchLandingPageContext();
  const { tracking } = searchLandingPageData;
  const { pageData, searchParametersContextV3, searchResultsContext, useUserContext } = tracking;

  useTrackView({
    user,
    pageData: deepOmitTypeName(pageData),
    useUserContext,
    pcaSearchResultParameters: searchParametersContextV3,
    pcaSearchResults: searchResultsContext,
  });
};
